import { useEffect, useState } from 'react';
import type { DailyStreakEntry } from '../api/puzzles.ts';
import { getDailyStreak } from '../api/puzzles.ts';
import { getMe } from '../api/users.ts';
import { useAuth } from './useAuth.ts';

export function useDailyStreak(): { entries: DailyStreakEntry[]; streak: number; loading: boolean } {
  const { isAuthenticated, getAccessTokenSilently } = useAuth();
  const [entries, setEntries] = useState<DailyStreakEntry[]>([]);
  const [streak, setStreak] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setEntries([]);
      setStreak(0);
      return;
    }

    let cancelled = false;
    setLoading(true);

    async function fetch() {
      try {
        const token = await getAccessTokenSilently();
        const [data, me] = await Promise.all([getDailyStreak(token), getMe(token)]);
        if (!cancelled) {
          setEntries(data.dailySolves);
          setStreak(me.streak);
        }
      } catch {
        // best-effort
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetch();
    return () => { cancelled = true; };
  }, [isAuthenticated, getAccessTokenSilently]);

  return { entries, streak, loading };
}
